import { render, staticRenderFns } from "./GenreLibrary.vue?vue&type=template&id=0a56cc88"
import script from "./GenreLibrary.vue?vue&type=script&lang=ts"
export * from "./GenreLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports